export const all_routes = {
  // dashboard routes
  dealsDashboard: "/dashboard",
  leadsDashboard: "/dashboard/leads-dashboard",
  projectDashboard: "/dashboard/project-dashboard",
  profile: "/profile",
  forcedChangePassword: "/change-password",

  contactList: "/employees",
  addEmployee: "/employees/add",
  editEmployee: "/employees/edit/:id",
  EmployeeTypes: "/employee-types",
  farmList: "/farms-list",
  addFarm: "/farms/add",
  editFarm: "/farms/edit/:id",
  teamList: "/team-list",
  customers: "/customers",
  addCustomer: "/customers/add",
  editCustomer: "/customers/edit/:id",

  allReports: "/reports/all-reports",
  submissionReports: "/reports/submission-reports",
  attendance: "/attendance",
  vanPhoto: "/van-photo",

  //userManagement routes
  rolesPermissions: "/user-management/roles-permissions",
  permissions: "/user-management/permissions",
  permissionsV2: "/user-management/permissions-v2",
  roleVisibility: "/user-management/role-visibility",
  calendarVisibility: "/user-management/calendar-visibility",

  //customerManagement routes
  customerPermissions: "/customer-management/permissions",
  ManageCustomerPermissions: "/manage-customer-permissions/:id",

  //HR Management
  ExtraWages: "/hr/extra-wages",
  TrackingList: "/tracking",
  Volunteer: "/volunteer-list",
  ClothingItem: "/ClothingItem-list",
  ClothingRequest: "/ClothingRequest-list",
  ClothingReturn: "/ClothingReturn-list",
  HolidayRequest: "/HolidayRequest-list",
  ContractType: "/ContractType-list",
  Department: "/Department-list",
  EmployeeCompany: "/EmployeeCompany-list",
  LeaveType: "/LeaveType-list",
  areas: "/hr/areas",

  // Tenancy: platform-admin company management (Guides/TENANCY-DESIGN.md
  // §7.1). Distinct from the unrelated /super-admin/* template demo pages.
  tenants: "/platform-admin/companies",
  addTenant: "/platform-admin/companies/add",
  tenantUsers: "/platform-admin/companies/:tenantId/users",
  tenantModules: "/platform-admin/companies/:tenantId/modules",
  tenantShares: "/platform-admin/sharing",
  tenantDataReplication: "/platform-admin/replication",
  tenantDataCopy: "/platform-admin/replication",

  //Super Admin
  superadminDashboard: "/super-admin/dashboard",
  superadminCompany: "/super-admin/company",
  superadminSubscription: "/super-admin/subscription",
  superadminPackagelist: "/super-admin/packages",
  superadminPackageGrid: "/super-admin/packages-grid",
  superadminDomain: "/super-admin/domain",
  superadminPurchaseTransaction: "/super-admin/purchase-transaction",
  deleteRequest: "/user-management/delete-request",

  //crm routes
  activityCalls: "/crm/activity-calls",
  manageusers: "/user-management/manage-users",

  teamDetails: "/team-details/:id",
  activityMail: "/crm/activity-mail",
  activityTask: "/crm/activity-task",
  activityMeeting: "/crm/activity-meeting",
  activities: "/crm/activities",
  payments: "/crm/payments",
  tasks: "/crm/tasks",
  tasksImportant: "/crm/tasks-important",
  tasksCompleted: "/crm/tasks-completed",
  campaign: "/crm/campaign",
  campaignComplete: "/crm/campaign-complete",
  campaignArchieve: "/crm/campaign-archieve",
  addCampaign: "/crm/addCampaign",
  analytics: "/crm/analytics",
  contactDetails: "/crm/contact-details",
  deals: "/crm/deals",
  dealsDetails: "/crm/deals-details",
  dealsKanban: "/crm/deals-kanban",
  leadsKanban: "/leads-kanban",
  pipeline: "/crm/pipeline",
  projects: "/crm/projects",
  companyDetails: "/crm/company-details",
  projectDetails: "/crm/project-details",
  contactGrid: "/crm/contact-grid",
  companiesGrid: "/crm/companies-grid",
  compaignComplete: "/crm/compaign-complete",
  companies: "/companies",
  leadsDetails: "/leads-details",
  leads: "/leads",
  projectsGrid: "/crm/project-grid",
  ProposalsList: "/crm/proposals-list",
  ProposalsGrid: "/crm/proposals-grid",
  ProposalsView: "/crm/proposals-view",
  ContractsList: "/crm/contracts-list",

  ContractsGrid: "/crm/contracts-grid",
  InvoiceList: "/crm/invoice-list",
  InvoiceGrid: "/crm/invoice-grid",
  estimationList: "/crm/estimation-list",
  estimationKanban: "/crm/estimation-kanban",

  bankAccounts: "/bank-accounts",
  blankPage: "/blank-page",
  calendar: "/calendar",
  dataTables: "/data-tables",
  tablesBasic: "/tables-basic",
  notes: "/notes",
  comingSoon: "/coming-soon",

  // auth routes routes
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  twoStepVerification: "/two-step-verification",
  success: "/success",
  emailVerification: "/email-verification",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  // Emailed invitation to join another company with an existing account
  // (backend TenantMembership.BuildAcceptUrl builds this path).
  acceptInvite: "/accept-invite",

  //ui routes
  alert: "/ui-alert",
  accordion: "/ui-accordion",
  avatar: "/ui-avatar",
  badges: "/ui-badges",
  border: "/ui-border",
  breadcrums: "/ui-breadcrums",
  button: "/ui-buttons",
  buttonGroup: "/ui-button-group",
  cards: "/ui-cards",
  carousel: "/ui-carousel",
  colors: "/ui-colors",
  dropdowns: "/ui-dropdowns",
  grid: "/ui-grid",
  images: "/ui-images",
  lightbox: "/ui-lightbox",
  media: "/ui-media",
  modals: "/ui-modals",
  navTabs: "/ui-navtabs",
  offcanvas: "/ui-offcanvas",
  pagination: "/ui-pagination",
  placeholder: "/ui-placeholder",
  popover: "/ui-popover",
  progress: "/ui-progress",
  rangeSlider: "/ui-rangeslider",
  spinner: "/ui-spinner",
  sweetalert: "/ui-alert",
  toasts: "/ui-toasts",
  tooltip: "/ui-tooltip",
  typography: "/ui-typography",
  video: "/ui-video",
  clipboard: "/ui-clipboard",
  counter: "/ui-counter",
  dragandDrop: "/ui-drag-drop",
  rating: "/ui-rating",
  ribbon: "/ui-ribbon",
  stickyNotes: "/ui-sticky-notes",
  textEditor: "/ui-text-editor",
  timeLine: "/ui-timeline",
  scrollBar: "/ui-scrollbar",
  apexChat: "/ui-apexchat",
  chart: "/ui-chartjs",
  falgIcons: "/ui-flag-icon",
  fantawesome: "/ui-fantawesome",
  materialIcon: "/ui-material-icon",
  pe7icon: "/ui-icon-pe7",
  simpleLineIcon: "/ui-simpleline",
  themifyIcon: "/ui-themify",
  typicon: "/ui-typicon",
  NotificationType: "/notification/types",
  NotificationSettings: "/notification/settings",
  NotificationTemplate: "/notification/template",
  AllNotifications: "/notifications",
  NotificationTemplatePermissions: "/notification/template-permissions/:id",
  SystemReport: "/notification/system-report",
  AdminNotificationPermissions: "/notification/admin-permissions",
  CheckInOutSettings: "/check-in-out/settings",
  SystemSettings: "/settings/system",
  weatherIcon: "/ui-weather-icon",
  basicInput: "/forms-basic-input",
  checkboxandRadion: "/form-checkbox-radios",
  inputGroup: "/form-input-groups",
  gridandGutters: "/form-grid-gutters",
  formSelect: "/form-select",
  formMask: "/form-mask",
  fileUpload: "/form-fileupload",
  horizontalForm: "/form-horizontal",
  verticalForm: "/form-vertical",
  floatingLable: "/form-floating-labels",
  formValidation: "/form-validation",
  reactSelect: "/select",
  formWizard: "/form-wizard",
  dataTable: "/tables-basic",
  tableBasic: "/data-tables",
  iconicIcon: "/icon-ionic",

  //base-ui
  uiAlerts: "/ui-alerts",
  uiAccordion: "/ui-accordion",
  uiAvatar: "/ui-avatar",
  uiBadges: "/ui-badges",
  uiBorders: "/ui-borders",
  uiButtons: "/ui-buttons",
  uiButtonsGroup: "/ui-buttons-group",
  uiBreadcrumb: "/ui-breadcrumb",
  uiCards: "/ui-cards",
  uiCarousel: "/ui-carousel",
  uiColor: "/ui-color",
  uiDropdowns: "ui-dropdowns",
  swiperjs: "/ui-swiperjs",
  sortable: "/ui-sortable",
  tablericons: "/icon-tabler",
  bootstrapicons: "/icon-bootstrap",
  remixicons: "/icon-remix",
  formpicker: "/form-pickers",
  mapleaflet: "/maps-leaflet",

  // pages routes
  error404: "/error-404",
  error500: "/error-500",
  underMaintenance: "/under-maintenance",

  // reports routes
  companyReports: "/reports/company-reports",
  contactReports: "/reports/contact-reports",
  dealReports: "/reports/deal-reports",
  leadReports: "/reports/lead-reports",
  projectReports: "/reports/project-reports",
  taskReports: "/reports/task-reports",
  sanitizedReports: "/reports/sanitized-reports",

  // application routes
  todo: "/application/todo",
  email: "/application/email",
  videoCall: "/application/video-call",
  chat: "/application/chat",
  audioCall: "/application/audio-call",
  callHistory: "/application/call-history",
  fileManager: "/application/file-manager",
  socialfeed: "/application/social-feed",
  kanbanview: "/kanbanview",
  invoice: "/application/invoice",
  invoice_details: "/application/invoice-details",

  // crmsetting routes
  sources: "/crm-setting/sources",
  contactStage: "/crm-setting/contact-stage",
  industry: "/crm-setting/industry",
  calls: "/crm-setting/calls",
  lostReason: "/crm-setting/lost-reason",

  //content routes
  pages: "/content/pages",
  cities: "/content/cities",
  states: "/content/states",
  testimonials: "/content/testimonials",
  countries: "/content/countries",
  faq: "/content/faq",

  //support routes
  contactMessages: "/support/contact-messages",
  tickets: "/support/tickets",

  // membership routes
  membershipplan: "/membership-plans",
  membershipAddon: "/membership-addons",
  membershipTransaction: "/membership-transactions",
  // Farms
  FarmDetails: "/farms-details",
  farmGrid: "/farms-grid",
  //Auditors
  auditors: "/auditors",
  auditType: "/audit/type",
  audit: "/audit",
  auditDetails: "/audit/auditDetails",
  auditReport: "/audit/report",
  auditReportSubmissions: "/audit/report-submissions",
  customerRequestReport: "/customer-request-report",
  shiftList: "/shifts",
  SiteType: "/SiteType-list",

  //Layouts Pages
  layoutMini: "/layout-mini",
  HorizontalSingle: "/layout-horizontal-single",
  WithoutHeader: "/layout-without-header",
  layoutRtl: "/layout-rtl",
  Detached: "/layout-detached",
  Dark: "/layout-dark",
  Vehicles: "/vehicles",
  DriverTripReport: "/driver-trip-report",
  DriverTripReportSettings: "/settings/driver-trip-report",
  Machines: "/machines",
  MachineAssignments: "/machine-assignments",

  nonConformancesReport: "/non-conformances-report",
  ncrSubmission: "/ncr-submission",
  Certifications: "/Certifications",

  // Important Documents
  importantDocs: "/important-docs",

  sopList: "/sop/list",
  trainingDashboard: "/training/dashboard",
  sopCreate: "/sop/create",
  sopEdit: "/sop/edit/:id",
  sopDetails: "/sop/details/:id",
  trainingList: "/training/modules",
  trainingCreate: "/training/modules/create",
  trainingEdit: "/training/modules/edit/:id",
  trainingCategories: "/training/categories",
  myTraining: "/sop/my-training",
  trainingPlayer: "/sop/training/:assignmentId",
  interactiveElearningDemo: "/sop/interactive-demo",
  sopAssign: "/sop/assign",
  trainingAssignments: "/training/assignments",
  trainingQuestions: "/training/modules/:trainingId/questions",
  trainingSlides: "/training/modules/:id/slides",
  trainingResults: "/training/modules/:trainingId/results",

  // Audit Document Request Routes
  submitAuditDocRequest: "/submit-doc-request",
  auditDocRequestDashboard: "/doc-request-dashboard",
  trainingRecordRequestDetail: "/doc-request-dashboard/:id",
  accessByToken: "/audit-doc-access/:accessToken",

  // Incident Report
  incidentReport: "/incident-report",

  // Auditor Timesheet
  auditorTimesheet: "/auditor-timesheet",

  // Audit Escalations (training failures escalated to auditors)
  auditEscalations: "/audit/escalations",

  // Employee Induction
  inductionList: "/inductions",
  inductionPending: "/inductions/pending",
  inductionSettings: "/inductions/settings",
  inductionCreateTemplate: "/inductions/settings/create",
  inductionDetail: "/inductions/:id",

  // Certificate Types
  certificateTypes: "/training/certificate-types",

  // Custom Email
  customEmail: "/communication/custom-email",

  // Custom WhatsApp
  customWhatsApp: "/communication/custom-whatsapp",
};
